/* Waddle In A Tee — hover-play image carousel on product cards.
   Loaded globally so it also covers async-loaded cards (e.g. product recommendations). */
(function () {
  var SPEED = 850;

  function setActive(imgs, idx) {
    for (var i = 0; i < imgs.length; i++) imgs[i].classList.toggle('is-active', i === idx);
  }

  function attach(box) {
    if (box.__hc) return;
    box.__hc = true;
    var imgs = [].slice.call(box.querySelectorAll('.hover-carousel__img'));
    if (imgs.length < 2) return;
    var card = box.closest('.card-gallery') || box.parentElement;
    if (!card) return;
    var timer = null, idx = 0, loaded = false;
    function load() {
      if (loaded) return;
      loaded = true;
      imgs.forEach(function (im) { if (im.dataset.src) { im.src = im.dataset.src; im.removeAttribute('data-src'); } });
    }
    card.addEventListener('pointerenter', function () {
      load();
      box.classList.add('is-hovering');
      if (timer) return;
      timer = setInterval(function () { idx = (idx + 1) % imgs.length; setActive(imgs, idx); }, SPEED);
    });
    card.addEventListener('pointerleave', function () {
      clearInterval(timer); timer = null; idx = 0; setActive(imgs, 0);
      box.classList.remove('is-hovering');
    });
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches('[data-hover-carousel]')) attach(root);
    if (root.querySelectorAll) {
      var b = root.querySelectorAll('[data-hover-carousel]');
      for (var i = 0; i < b.length; i++) attach(b[i]);
    }
  }

  function init() { scan(document.body || document.documentElement); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  // Catch cards injected after load (product recommendations, quick-add, infinite scroll, etc.)
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) scan(added[j]);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* Inline "Add to cart" buttons inside product descriptions -> trigger the main product-page ATC. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-waddle-atc]') : null;
    if (!btn) return;
    e.preventDefault();
    var main = document.querySelector('[data-testid="standalone-add-to-cart"]')
      || document.querySelector('product-form-component .add-to-cart-button')
      || document.querySelector('form[action*="/cart/add"] [name="add"]');
    if (main) main.click();
  }, false);
})();
